<template>
  <div class="menu-wrapper">
    <div class="menu-logo" :style="{ padding: collapse ? '20px 6px' : '20px' }">
      <img class="header-logo" src="@/assets/images/logo_small.png" alt="" />
      <span v-if="!collapse">一物一码溯源管理</span>
    </div>
    <template v-for="item in routes">
      <template v-if="!item.checked && item.children">
        <router-link
          v-if="
            hasOneShowingChildren(item.children) && !item.children[0].children
          "
          :to="item.url + '/' + item.children[0].url"
          :key="item.children[0].permName"
        >
          <el-menu-item
            :index="item.url + '/' + item.children[0].url"
            :class="{ 'submenu-title-noDropdown': !isNest }"
          >
            <svg-icon
              v-if="item.children[0] && item.children[0].icon"
              :icon-class="item.children[0].icon"
            ></svg-icon>
            <span
              v-if="item.children[0] && item.children[0].permName"
              slot="title"
              >{{ item.children[0].permName }}</span
            >
          </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.url" :key="item.url">
          <template slot="title">
            <svg-icon
              v-if="item && item.icon"
              :icon-class="item.icon"
            ></svg-icon>
            <span v-if="item && item.permName" slot="title">{{
              item.permName
            }}</span>
          </template>
          <template v-for="child in item.children">
            <template v-if="!child.checked">
              <sidebar-item
                :is-nest="true"
                class="nest-menu"
                v-if="child.children && child.children.length > 0"
                :routes="[child]"
                :key="child.url"
              ></sidebar-item>

              <router-link
                v-else
                :to="item.url + '/' + child.url"
                :key="child.url"
              >
                <el-menu-item :index="item.url + '/' + child.url">
                  <svg-icon
                    v-if="child && child.icon"
                    :icon-class="child.icon"
                  ></svg-icon>
                  <span v-if="child && child.permName" slot="title">{{
                    child.permName
                  }}</span>
                </el-menu-item>
              </router-link>
            </template>
          </template>
        </el-submenu>
      </template>
      <router-link v-else :to="item.url" :key="item.permName">
        <el-menu-item :index="item.url">
          <svg-icon v-if="item.icon" :icon-class="item.icon"></svg-icon>
          <span v-if="item.permName" slot="title">{{ item.permName }}</span>
        </el-menu-item>
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    },
    collapse: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        //console.log("item:" + JSON.stringify(item))
        //console.log("!item.checked:" + !item.checked)
        return !item.checked;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.menu-logo {
  font-size: 14px;
  padding: 20px;
  color: white;
  .header-logo {
    width: 20px;
    height: auto;
    vertical-align: bottom;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue